import { makeGlobalRegexp } from './regularExpression'
import { WEB_URL_SEARCH_REGEXP } from './urlValidation'

/**
 * Get clean url, i.e remove hash and qiuery/search string
 */
export function cleanUrl(urlOrString: string) {
  const url = new URL(urlOrString, window.location.href)
  url.hash = ''
  url.search = ''
  return url.toString()
}

export function getCommonUrlPart(urls: string[]) {
  if (urls.length === 0) return ''
  const parsedUrls = urls.map((u) => new URL(u, window.location.href))

  const expectedOrigin = parsedUrls[0].origin
  if (!parsedUrls.every((u) => u.origin === expectedOrigin)) {
    // if they don't share origin then give up
    return ''
  }

  let currentCommonPathCandidate = dirname(parsedUrls[0].pathname)
  while (currentCommonPathCandidate !== '') {
    if (parsedUrls.every((u) => u.pathname.startsWith(currentCommonPathCandidate))) {
      const resultUrl = parsedUrls[0]
      resultUrl.pathname = currentCommonPathCandidate + '/'
      return resultUrl.toString()
    }
    currentCommonPathCandidate = dirname(currentCommonPathCandidate)
  }
  return ''
}

export function dirname(pathname: string) {
  const lastSlashIndex = pathname.lastIndexOf('/')
  if (lastSlashIndex === -1) return pathname

  return pathname.substring(0, lastSlashIndex)
}

export function downloadUrlAsFile(url: string, filename?: string) {
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', filename || url)

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const ABSOLUTE_URL_REGEXP = /^[a-z]+?:(\/\/)?|^\/\//
export function forceAbsoluteUrl(url: string) {
  if (ABSOLUTE_URL_REGEXP.test(url)) return url
  return `//${url}`
}

export function countHyperlinks(content: string) {
  return content.match(makeGlobalRegexp(WEB_URL_SEARCH_REGEXP))?.length ?? 0
}
